import React, { useState, useEffect, useRef } from "react";
import { serverURL } from "../../config/urls";
import CompletionPopup from "../completion-popup";
import { logEvent } from '@firebase/analytics';
import {analytics} from '../../config/firebase-logging';
import { useCareerContext } from '../career-context';

export function ChatWithStudent() {
    const {
        isPopupOpen,
        setIsPopupOpen,
        handleError,
        handleNotification,
        startConfetti
    } = useCareerContext();
    const [inputValue, setInputValue] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [conversationId, setConversationId] = useState("");
    const [chat, setChat] = useState([
        { "role": "assistant", "content": "I'm ready to learn about adding and subtracting fractions!" }
    ]);

    const chatboxRef = useRef(null);

    useEffect(() => {

        // Scroll to bottom of chatbox
        chatboxRef.current.scrollTop = chatboxRef.current.scrollHeight;
    }, [chat]);

    function sendMessage() {
        
        if (isLoading) {
            handleError("Rebecca is either still typing, or if you got feedback, you have finished the exercise")
            return
        }
        if (process.env.REACT_APP_ENVIRONMENT === "production") {
            logEvent(analytics, 'career_interaction')
        }
        setIsLoading(true);
        // Add newest question to chat
        const userMessage = inputValue;
        const newChat = [...chat, { "role": "user", "content": userMessage }, { "role": "assistant", "content": "..." }];
        setChat(newChat);

        // Clear input box
        setInputValue("");
        fetch(serverURL + "/chat-with-student",
            { headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}`, "Content-Type": "application/json" }, method: "POST", body: JSON.stringify({ 
                message: newChat.slice(0, -1), 
                conversationId: conversationId 
            }) })
            .then(response => response.json())
            .then(data => {
                if (!conversationId) {
                    setConversationId(data.conversationId);
                }
                const { error, message } = data;
                const chatWithoutLoader = newChat.slice(0, -1);
                if (error) {
                    setChat(chatWithoutLoader);
                    handleError(message);
                } else {
                    // set chat with response
                    setChat([...chatWithoutLoader, { "role": "assistant", "content": message }]);
                }
                setIsLoading(false);

            })
            .catch(err => {
                handleError("An unknown error occured");
                setIsLoading(false);
            });
    }
    
    function handleKeyDown(e) {
        if (e.key === "Enter") {
            e.preventDefault();
            // Don't send empty message or if sending message
            if (inputValue === "" || isLoading) {
                return
            }
            sendMessage();
        }
    }

    function getTeachingFeedback() {
        if (isLoading) {
            handleError("Rebecca is either still typing, or if you got feedback, you have finished the exercise")
            return
        }
        setIsLoading(true);
        // Add newest question to chat
        const userMessage = "Please rate my teaching in no more than 5 sentences. Include areas of improvement, if any, and what you liked about my teaching.";
        const chatWithLoader = [...chat, { "role": "assistant", "content": "..." }];
        setChat(chatWithLoader);
        const chatWithFeedback = [...chat, { "role": "user", "content": userMessage }];
        // Clear input box
        setInputValue("");
        fetch(serverURL + "/chat-with-student",
        { headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}`, "Content-Type": "application/json" }, method: "POST", body: JSON.stringify({ message: chatWithFeedback }) })
            .then(response => response.json())
            .then(data => {
                const { error, message } = data;
                const chatWithoutLoader = chatWithLoader.slice(0, -1);
                if (error) {
                    handleError(message);
                    setChat(chatWithoutLoader);
                } else {
                    // set chat with response
                    setChat([...chatWithoutLoader, { "role": "assistant", "content": message }]);
                    setIsPopupOpen(true);
                    startConfetti();
                }

            })
            .catch(err => {
                handleError("An unknown error occured");
            });            
    }


    return (
        <div className="chat-with-student">
            {isPopupOpen && <CompletionPopup title="Great job!" message="You've successfully taught your first student! Take a look at the feedback you were given." hidePopup={()=>setIsPopupOpen(false)}/>}
            <div className="chat-section">
                <div className="chat-header row">
                    <img alt="rebecca" src={require("../../img/student-icon.png")} height="50px" />
                    <p>Rebecca</p>
                </div>
                <div className="chatbox" ref={chatboxRef}>
                {chat.map((message, index) => (
                    (message.role === "user" || message.role === "assistant") && (
                        <div className={"chat-message row " + message.role} key={index} style={{ justifyContent: "space-between", alignItems: "flex-end" }}>
                            <div>
                                {(message.role === "assistant") ? <img alt="student" src={require("../../img/student-icon.png")} height="30px" /> : <img alt="chatbot" src={require("../../img/user.png")} height="30px" />}
                            </div>
                            <div className='message-content'>
                                <p>{message.content}</p>
                            </div>
                        </div>
                    )
                ))}
                </div>
                <div className="feedback">
                    <p onClick={getTeachingFeedback}>Rate my teaching!</p>
                </div>
                <div className="chat-input row" onKeyDown={handleKeyDown}>
                    <input type="text" value={inputValue} onChange={(e)=>setInputValue(e.target.value)}  placeholder="Type your message here..." />
                    <button type="submit" className="send-btn" onClick={sendMessage} ><i className="fa fa-paper-plane" style={{ color: 'white' }}></i></button>
                </div>
            </div>
        </div>
    )
}